export default "../css/eb1bb4437168e0405ca215b77124aa1f.ttf";